<span
  class="ui-checkbox-box"
  [attr.aria-hidden]="readonly() ? true : null"
  [attr.aria-checked]="isIndeterminate() ? 'mixed' : isChecked()"
>
  @if (isChecked()) {
    <i class="fa-solid fa-check" aria-hidden="true"></i>
  } @else if (isIndeterminate()) {
    <i class="fa-solid fa-minus" aria-hidden="true"></i>
  }
</span>

@if (label()) {
  <span class="ui-checkbox-label">{{ label() }}</span>
}
